/**
 * Initialization of step 3
 */
const initStepVerification = () => {
  /**
   * Verification code
   */
  // Variables
  var $verificationCodeInput = $("#verification-code");
  var $submitButton = $('input[type="submit"]');
  var $form = $("form[data-verification-step]");

  $submitButton.prop("disabled", true);

  // Clean the token input by default
  $verificationCodeInput.val("");

  // Focus the verification code on ready
  $verificationCodeInput.focus();

  // To uppercase and validation of verification code on input
  $verificationCodeInput.on("input", function () {
    // Get the current value
    $(this).val($(this).val().toUpperCase());

    // Validate the token if the length is 4
    if ($(this).val().length === 4) {
      // Get mobile number and token
      var mobile = $(this).attr("data-mobile");
      var token = $(this).val();

      // Validate token
      $.ajax({
        type: "POST",
        url: fpreTokenValidationUrl,
        data: {
          mobile: mobile,
          token: token,
        },
        success: function (_data, _textStatus, xhr) {
          // Make token readonly and enable submit button on success
          if (xhr.status === 200) {
            // Make input readonly and enable submission
            $verificationCodeInput.prop("readonly", true);
            $verificationCodeInput.val(token);
            $submitButton.prop("disabled", false);
            $submitButton.focus();
          }
        },
      });
    }
  });

  $form.submit(function () {
    $submitButton.prop("disabled", true);

    setTimeout(function () {
      $submitButton.prop("disabled", false);
    }, 5000);
  });
};

export { initStepVerification };
